export default {
    handle(bloodDonorModel) {
        if (!bloodDonorModel.membership_fee_image || !bloodDonorModel.membership_fee_image.length) {
            return true;
        }

        bloodDonorModel.membership_fee_image = bloodDonorModel.membership_fee_image.filter(item => !item.hasOwnProperty('id') || !item.hasOwnProperty('uuid'));

        return true;
    }
}